import React, { useCallback } from 'react';

import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';

import API from 'utils/api';
import { useAuth, useSources } from 'hooks';
import { host } from 'components/theme';
import { ButtonContainer, Table } from 'components';

import styles from './HostEventList.module.scss';

const HostEventList = () => {
  const auth = useAuth();
  const sources = useSources();

  const fetchData = useCallback(
    ({ search, ...rest }) => {
      const query = { active: true, host: auth.user._id };

      if (search) {
        query.name = { $regex: search, $options: 'i' };
      }

      return API.getChannelEvents(
        {
          ...rest,
          select: 'name channel active',
          populate: ['channel'],
          query: JSON.stringify(query),
        },
        sources
      );
    },
    [sources]
  );

  return (
    <ThemeProvider theme={host}>
      <div className={styles.hostEventList}>
        <ButtonContainer position="top" />

        <Table
          data={fetchData}
          title="Host Events"
          columns={[
            {
              title: 'Name',
              field: 'name',
              defaultSort: 'asc',
              weight: 2,
            },
            { title: 'Channel', field: 'channel.name', weight: 2 },
            {
              title: 'Active',
              field: 'active',
              align: 'center',
              render: ({ active }) => (active ? 'Yes' : 'No'),
            },
            {
              title: '',
              sorting: false,
              align: 'center',
              render: ({ _id: id }) => (
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to={{
                    pathname: `/dashboard/channel/host/event`,
                    state: { id },
                  }}
                >
                  Manage
                </Button>
              ),
            },
          ]}
        />
      </div>
    </ThemeProvider>
  );
};

export default HostEventList;
